<template>
  <div>
    <h1>{{ options.model.contract_number }} - {{ i18n.app.components.contract_sign_off.dialog.header }}</h1>

    <div>
      <p class="text-danger">{{ i18n.app.components.contract_sign_off.dialog.body }}</p>
    </div>

    <Form ref="form" v-if="state.ready" :onSubmit="onSubmit" :onSuccess="onSuccess">

      <HiddenInput :model="formData" name="location_type_return" />

      <div v-if="formData.location_type_return == LocationType.OTHER && is_pick_up_costs_covered === false">
        <p>
          <small class="text-danger">
            {{ i18n.app.components.contract_sign_off.dialog.message.pick_up_costs }}
          </small>
        </p>

        <Checkbox
          :indent="false"
          :model="formData"
          name="accept_pickup_costs"
          :label="lang.accept_pickup_costs"
        />
      </div>

      <FormGroup name="address_return">
        <FormGroupAddress
          v-if="formData.location_type_return == LocationType.OTHER"
          :withName="true"
          :model="formData.address_return"
          :countries="countries"
        />
      </FormGroup>

      <hr />

      <TextInput :model="formData" :label="i18n.app.components.contract.email" name="email" />

      <TextInput :model="formData" :label="i18n.app.components.contract.mileage" name="mileage" />

      <TextInput
        :model="formData"
        :label="i18n.app.components.contract.return_information"
        name="signed_off_remark"
        minHeight="150px"
        :multiline="true"
      />

      <RadioGroup
        :model="formData"
        name="is_fully_refueled"
        :label="lang.is_fully_refueled"
        @change="$forceUpdate()"
        :options="is_fully_refueled_options"
      />

      <RadioGroup
        v-if="options.model.vehicle?.should_ask_for_charging_cable_presence"
        :model="formData"
        name="charging_cable_count"
        :label="lang.charging_cable"
        @change="$forceUpdate()"
        :options="charging_cable_count_options"
      />

      <!-- <TextInput
        v-if="formData.is_fully_refueled === 0"
        :model="formData"
        :label="`${i18n.app.components.contract.tank_level} (%)`"
        name="tank_level_percentage"
      />-->

      <!-- <DatePicker :label="lang.signed_off_at" :model="formData" name="signed_off_at" /> -->

      <div class="pb-2">
        <small>
          {{ i18n.app.components.contract_sign_off.dialog.footer }}
        </small>
      </div>
    </Form>
    <div class="row">
      <div class="col-md-6">
        <a @click="onCancelClick" tabindex="0" class="btn btn-primary">{{ i18n.app.common.cancel }}</a>
      </div>
      <div class="col-md-6 text-right">
        <a :disabled="!state.ready" @click="onSubmitClick" class="btn btn-secondary">{{ i18n.app.common.confirm }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js";
import dialogMixin from "@/mixins/dialog.mixin";
import { ContractService } from "../../../../services";
import { LocationType } from "@/models/Contract";
import pick from "lodash/pick";

import {
  TextInput,
  RadioGroup,
  Checkbox,
  Select,
  Form,
  FormGroup,
  FormGroupAddress,
  DatePicker,
  HiddenInput
} from "@/components/common/form";
import dayjs from 'dayjs';

export default {
  name: "contract-sign-off-dialog",
  props: ["options"],
  mixins: [DialogMixin, dialogMixin],
  components: {
    TextInput,
    RadioGroup,
    Select,
    FormGroup,
    FormGroupAddress,
    DatePicker,
    Form,
    Checkbox,
    HiddenInput
  },
  data() {
    return {
      state: {
        ready: false
      },
      contractService: new ContractService(),
      model: this.options.model,
      formData: {
        location_type_return: LocationType.OTHER,
        accept_pickup_costs: null,
        address_return: this.options.model.address_return,
        // Filled from the sign-off endpoint below; the contract list no longer
        // carries the driver's email.
        email: null,
        mileage: this.options.model.vehicle.mileage_current,
        signed_off_remark: this.options.model.signed_off_remark,
        is_fully_refueled: this.options.model.is_fully_refueled,
        charging_cable_count: null,
        tank_level_percentage: this.options.model.tank_level_percentage,
        signed_off_at: this.options.model.signed_off_at,
      },
      depots: [],
      lang: i18n.app.components.contract,
      is_pick_up_costs_covered: null,
      LocationType: LocationType,
      location_types_return: [],
      countries: [],
      is_fully_refueled_options: [],
      charging_cable_count_options: []
    };
  },
  mounted() {
    this.contractService.createSignOff(this.model.id).then(data => {
      this.formData.email = data.email;
      this.location_types_return = data.location_types_return;
      this.depots = data.depots;
      this.countries = data.countries;
      this.is_fully_refueled_options = data.is_fully_refueled_options;
      this.charging_cable_count_options = data.charging_cable_count_options;
      this.is_pick_up_costs_covered = data.is_pick_up_costs_covered
      this.state.ready = true;

      this.$forceUpdate();
    }).catch(e => {
      console.log(e);
      this.showSimpleMessage(i18n.messages.something_went_wrong);
    });
  },
  methods: {
    onSubmitClick() {
      if (!this.state.ready) return;

      this.$refs.form.submit(this.formData);
    },
    onSuccess() {
      this.proceed();
    },
    onSubmit(formData) {
      return this.contractService.signOff(this.model.id, {
        ...formData,
        signed_off_at: dayjs().format('YYYY-MM-DD HH:mm'),
        is_pick_up_costs_covered: this.is_pick_up_costs_covered
      });
    },
    onCancelClick() {
      this.cancel(); // included in DialogMixin
    }
  }
};
</script>
